// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"4312dccea18af26e158b","883":"9b27013b3f37082640a2"}[chunkId] + ".js";
};